import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { ServerDocTypeLineResponseDtoModel } from "../../../data-transfer-objects/server-doc-type-line-dto.model";

@Injectable({
  providedIn: "root",
})
export class ServerDocTypeLineService extends BaseApiTemplateService<ServerDocTypeLineResponseDtoModel[]> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  "generic-doc/server-doc-types/lines";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "generic-doc/server-doc-types/lines";
    this.httpClient = http;
  }

}